import {
  ApplicationConfig,
  importProvidersFrom,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { APP_ROUTES } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { appHttpInterceptors } from './app.route-providers';
import { provideStore } from '@ngrx/store';
import { provideAuthServices } from '@core/states/auth/provide-auth-services';
import { provideDialog } from '@group24ag/flowkit';
import { provideStoreDevToolsInLocal } from './provide-store-dev-tools';
import { marked } from 'marked';
import { markedHighlight } from 'marked-highlight';
import hljs from 'highlight.js';
import mermaid from 'mermaid';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { environment } from '@environment/environment';
import { provideColorTheme } from '@core/theming/provide-color-theme';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(APP_ROUTES, withComponentInputBinding()),
    provideAnimations(),
    provideHttpClient(withInterceptors(appHttpInterceptors)),
    provideAuthServices(),
    provideStore(),
    provideStoreDevToolsInLocal(),
    provideDialog(),
    provideColorTheme(),
    importProvidersFrom(
      LoggerModule.forRoot({
        disableConsoleLogging: environment.production,
        level: NgxLoggerLevel.DEBUG,
      })
    ),
  ],
};

marked.use(
  markedHighlight({
    langPrefix: 'hljs language-',
    highlight(code: string, lang: string) {
      const language = hljs.getLanguage(lang) ? lang : 'plaintext';
      return hljs.highlight(code, { language }).value;
    },
  })
);

// Configure marked to use highlight.js
marked.setOptions({
  highlight: (code: string, lang: string) => {
    if (lang && hljs.getLanguage(lang)) {
      return hljs.highlight(code, { language: lang }).value;
    }
    return hljs.highlightAuto(code).value;
  },
} as any);

mermaid.initialize({ startOnLoad: false });
